<template>
  <div class="horizontal layout center center-justified fit">
    <Loading />
  </div>
</template>

<script>
import { authentication, app } from '@microsoft/teams-js'
import utils from '@/util'

// components
import Loading from '@/components/Loading'

// services
import cookie from '@/services/cookie'

import { PRESENTER_REGISTER } from '@/constant/eventCategories'

export default {

  components: {
    Loading,
  },
  data() {
    return {
      isMSTeamsApp: false,
    }
  },
  async created() {
    const hasMSTeamsParamsInUrl = utils.getParamValue('ms_teams', window.location.href)
    this.isMSTeamsApp = hasMSTeamsParamsInUrl || (localStorage.getItem('ms_teams') == 'true')
  },
  async mounted() {
    const {
      token,
      signup,
      admin,
      provider,
      isNew,
    } = this.$route.query

    if (!token) {
      this.$router.push('/pages/login')
      return
    }

    this.$store.dispatch('setCurrentUserAction', {})

    if (isNew) {
      cookie.setValue('aha-new-user', true)
    }
    const isGuest = cookie.getValue('aha-guest-user')
    if (isGuest) {
      cookie.deleteValue('aha-guest-user')
    }

    utils.setCookieToken(token)
    this.$http.headers.common.Authorization = `Bearer ${token}`
    try {
      if (this.isMSTeamsApp) {
        await app.initialize()
        authentication.notifySuccess(token)
      }
    } catch {
      // do nothing
    }

    if (signup == 1) {
      this.$store.state.isComeFromSignupPage = true
      this.$router.push({ name: 'Presentations' })
      return
    }

    if (admin) {
      this.$router.push({
        path: '/apps/presentations',
        query: { admin: true },
      })
      this.$store.state.isAdmin = true
      sessionStorage.setItem('isAdmin', 'true')
      return
    }

    if (provider) {
      utils.mixpanelTracking(
        PRESENTER_REGISTER, 'Sign up',
        'SSO',
        null,
        {
          provider,
        },
      )
      utils.trackGA4AndMixpanel('sign_up', {
        method: 'SSO',
      })
    }

    this.$router.push('/apps/presentations')
  },
}
</script>
